import * as ExpressionRelationship from "../../constants/ExpressionRelationship";
import * as Operator from "../../constants/Operator";

export class HierarchyFilterHelper {
    constructor(propertyName) {
        this.propertyName = propertyName;
    }

    createSelectedNodeExpressions(selectedNode) {
        if (!selectedNode)
            return [];
        return [this.createFilter(selectedNode.id)];
    }

    createFilter(value) {
        return {
            field: this.propertyName,
            operator: Operator.Contains,
            rightHandSide: value.replaceAll("-", ""),
            relation: ExpressionRelationship.AND
        };
    }

}